function setupModal(modalId, closeButtonSelector, iframeSelector) {
  // Obtener el elemento del modal
  const modal = document.getElementById(modalId);

  // Verificar si el modal existe
  if (modal) {
    // Obtener el botón de cierre y el iframe del video de Vimeo
    const closeBtn = modal.querySelector(closeButtonSelector);
    const iframe = modal.querySelector(iframeSelector);

    // Crear una instancia del reproductor de Vimeo
    const player = new Vimeo.Player(iframe);

    // Función para cerrar el modal y detener el video
    function closeModal() {
      modal.style.display = 'none';
      player.pause();
    }

    // Agregar evento de clic al botón de cierre
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Agregar evento de clic fuera del modal para cerrarlo
    window.addEventListener('click', function(event) {
      if (event.target === modal) {
        closeModal();
      }
    });
  }
}